export {CtaBig} from './lib/cta-big';